import * as yup from 'yup';


export const PlatformPersonEmploymentDataValidationScheme = yup.object().shape({
    startDate: yup.date()
        .required('Start Date is required')
        .typeError('Start Date is not a valid date'),
    endDate: yup
        .date()
        .nullable()
        .transform((curr, orig) => (orig === '' ? null : curr))
        .when('startDate', (startDate, schema) => {
            return schema.test('endDate', 'End Date must be greater than Start Date', function (
                endDate: any
            ) {
                if (!endDate || !startDate) {
                    return true;
                }
                return endDate > startDate;
            });
        }),
    jobTitle: yup.string().required('Job Title is required').max(128, 'Job title must be less than 128 characters'),
    employmentTypeId: yup.number().required('Employment Type is required').typeError('Employment Type is required'),
    occupationalLevelId: yup.number().required('Occupational Level is required').typeError('Occupational Level is required'),
    municipalityId: yup.number().nullable().transform((curr, orig) => (orig === '' ? null : curr)),
    provinceId: yup.number().required('Province is required').typeError('Province is required'),
    siteName: yup.string().max(128, 'Site name must be less than 128 characters').nullable()
});
